import { isEditMode } from '@js/utils';
import Cookies from 'js-cookie';

export default class LanguageSwitch {
  constructor(rootNode, props) {
    if (isEditMode()) {
      return;
    }

    this.$refs = {
      rootNode: rootNode,
      switchButton: rootNode.querySelector('.language-switch a'),
    };

    if (this.$refs.switchButton) {
      this.$refs.switchButton.addEventListener('click', this.createCookie.bind(this));
    }
  }

  createCookie() {
    Cookies.set('languageSwitch', 'true', {
      path: '/',
      expires: 30, // in days
      sameSite: true,
    });
  }
}
